import {Pressable, StyleSheet, View, ViewStyle} from "react-native";
import {UserAvatar} from "@/lib/types";
import Avatar from "@/lib/components/Avatar";
import {ReactNode, useMemo} from "react";
import Split from "@/lib/components/Split";
import Icon, {IconKind} from "@/lib/components/Icon";

type Props = {
    avatars: UserAvatar[],
    color: string,
    size?: number,
    numItems?: number,
    border?: boolean,
    icon?: IconKind,
    onPress?: () => any,
    children?: ReactNode;
}

export default function AvatarBox({avatars, color, children, border, icon, size, numItems, onPress}: Props) {
    const borderStyle: ViewStyle = border === false ? {
        minHeight: 0,
    } : {
        borderRadius: 7,
        borderWidth: 1,
        paddingLeft: 8,
        paddingRight: 12,
        paddingVertical: 8,
        minHeight: 48,
        borderColor: color,
    };
    const maxAvatars = numItems || 8;
    const inner = useMemo(() => {
        return (
            <>
                {icon && <Icon kind={icon}/>}
                <View style={styles.inner}>
                    {avatars.slice(0, maxAvatars).map(avatar => (
                        <Avatar key={avatar.id} size={size} avatar={avatar}
                                pressable={!onPress}
                        />))}
                </View>
                {children}
            </>
        );
    }, [avatars, children, icon, maxAvatars, onPress, size]);
    return (
        <Pressable style={[styles.container, borderStyle]} disabled={!onPress} onPress={onPress}>
            {border !== false &&
                <Split
                    left={<>
                        {inner}
                    </>}
                    right={<>
                        <Icon kind={"chevronRight"}/>
                    </>}/>
            }
            {border === false && inner}
        </Pressable>
    );
}

export const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%",
        alignItems: "center",
        alignContent: "center",
        gap: 8,
    },
    inner: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 4,
    }
})